module.exports = __webpack_public_path__ + "static/media/3pl5.ab025754.png";